import { ProfileState } from '../reducers/api/profile';

export const getUserName = (state): string => state.profile.username;

export const getProfileInfo = (state): ProfileState => state.profile;
